import * as React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      position: 'relative',
      minHeight: 200
    },
    loadingBackground: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255, 0.5)',
      zIndex: 3
    },
    loadingMessage: {
      fontSize: '1rem',
      marginBottom: '1rem'
    }
  })
);

type Props = {
  isLoading: boolean;
  className?: string;
  message?: string;
};

export const LoadingOverlay: React.FC<Props> = ({ isLoading, className, message, children }) => {
  const classes = useStyles();

  return (
    <div className={clsx(isLoading && classes.container, className)}>
      {isLoading && (
        <div className={classes.loadingBackground}>
          <div className={classes.loadingMessage}>{message}</div>
          <CircularProgress />
        </div>
      )}
      <>{children}</>
    </div>
  );
};
